<div class="container-fluid jornadas-programadas-page mt-3">
  <div class="spinner-container" *ngIf="!contentLoaded">
    <mat-spinner></mat-spinner>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 mx-auto text-center text-white">
      <app-alert [titulo]="'Jornadas Programadas'"></app-alert>
    </div>
  </div>
  <div class="row jornadas-filter-row">
    <div class="col-12 col-xl-6 ml-auto jornadas-filter-column">
      <app-filter-card class="jornadas-filter-card" [showRangePicker]="true" (filterEmit)="filter($event)" [hasLegajoInput]="false"
        [hasExportExcelButton]="true" (printExcelEmit)="printFile($event)"
        [useModernActions]="true" [filterButtonText]="'Buscar'" [exportExcelButtonDisabled]="!paramEntity.SpName"
        (valuesRangeEmit)="getRangeValues($event)">
      </app-filter-card>
    </div>
  </div>
  <div class="row jornadas-toolbar-row">
    <div class="col-12">
      <mat-card class="jornadas-toolbar-card">
        <mat-form-field appearance="outline" class="jornadas-search" subscriptSizing="dynamic">
          <mat-label>Filtrar registros</mat-label>
          <input matInput [(ngModel)]="inputFilterText" (keyup)="applyFilter($event)">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <button mat-raised-button class="btn-gray jornadas-assign-button" (click)="openModal()"
          [disabled]="!rowsSelected.rows?.length">Asignar Jornada</button>
      </mat-card>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="table-container">
        <table #matTable mat-table [dataSource]="dataSource" class="mat-elevation-z8">

          <!-- Agrupadores -->
          <ng-container *ngFor="let groupCol of groupColDef" [matColumnDef]="groupCol.colDef">
            <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'" [attr.colspan]="groupCol.colSpan"
              class="bg-agrupador text-white">
              {{ groupCol.colDef }}
            </th>
          </ng-container>

          <!-- Filas subcolumnas -->
          <ng-container *ngFor="let col of columnsDef, let i = index" [matColumnDef]="col"
            [sticky]="isSticky(col, null)">
            <div *ngIf="col !== 'accion';else btnAction">
              <th class="border bg-title" mat-header-cell *matHeaderCellDef> {{ col }} </th>
              <td class="border" mat-cell *matCellDef="let element" matTooltip="{{ getCellTooltip(element[col], col) }}"
                [ngClass]="isSticky(col, element)" (click)="get(col, element)">
                {{ getCellData(element[col], col) }}
              </td>
            </div>

            <ng-template #btnAction>
              <th mat-header-cell *matHeaderCellDef class="border text-white"> </th>
              <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                <mat-checkbox #chkBox (change)="checkboxSelect($event, element); selected = i">
                </mat-checkbox>
              </td>
            </ng-template>

          </ng-container>

          <!-- Nombres de agrupadores -->
          <tr mat-header-row *matHeaderRowDef="groupColHeaders; sticky: true"></tr>

          <!-- Nombres de columnas -->
          <tr mat-header-row *matHeaderRowDef="columnsDef; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsDef;" [ngClass]="getRowClassCondition(row)"></tr>
        </table>
      </div>


      <mat-paginator #detallePaginator class="jornadas-paginator" [pageSizeOptions]="[1000, 500]"></mat-paginator>
    </div>
  </div>
</div>
